import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=0ffc1896"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"
import style0 from "./Course.vue?vue&type=style&index=0&id=0ffc1896&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports